<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: space-between">
        <input-select selectTitle="缴费状态" :selectKey="'payStatus'" :selectData="payStatusList" @search="search" style="margin-right: 10px;"/>
        <!--<input-select selectTitle="缴费方式" :selectKey="'payChannel'" :selectData="payChannelList" @search="search"/>-->
      </div>
      <div style="display: flex;justify-content: space-between;">
        <input-search placeholder="缴费人" @search="searchKey" />
        <button-export
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          v-if="permissionCodes.indexOf('013015002') !== -1"
          style="margin-left: 10px;"
          value="导出"/>
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" @modifyInvoiceStatus="modifyInvoiceStatus" @statusChange="statusChange" @statusInfoChange="statusInfoChange" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/Finance'
  import {bus} from '../../../utils/bus'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nError, nSuccess} from "../../../utils/notice";

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'repair-finance-pay-record',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧财务',
          name: 'finance-over-view'
        }, {
          value: '报修账单',
        }],
        exportUrl: '',
        payStatusList: [
          {
            key: '',
            label: '全部'
          }, {
            key: '0',
            label: '未缴费'
          }, {
            key: '1',
            label: '已缴费'
          }, {
            key: '2',
            label: '已退款'
          }
        ],
        operationArr: ["modifyInvoiceStatus"],
        tableHead: [{
          prop: 'payer',
          label: '缴费人'
        }, {
          prop: 'money',
          label: '金额(元)'
        }, {
          prop: 'payStatusText',
          label: '缴费状态'
        }, {
          prop: 'payTime',
          label: '缴费时间'
        }, {
          prop: 'invoiceStatus',
          label: '开票状态',
          width: '120px',
          statusOnPageChangeStatus: 'invoiceStatusChangeStatus',
          statusList: [
            {
              code: '0',
              name: '未开票'
            }, {
              code: '1',
              name: '已开票'
            }, {
              code: '2',
              name: '开票中'
            }
          ],
          changeStatus: true
        }, {
          prop: 'invoiceNo',
          label: '发票号',
          width: '180px',
          statusOnPageChangeStatus: 'invoiceStatusChangeStatus',
          statusAlreadyOnPageChangeStatus: 'invoiceStatus',
          changeInfo: true
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        requestData: {
          searchKey: '',
          payChannel: '',
          payStatus: ''
        }
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      beforeDownload () {
        this.exportUrl = `${api.exportRepairBill}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&payStatus=${this.requestData.payStatus}`
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getRepairBillPage, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                v.code = v.billNo
                v.invoiceStatusChangeStatus = true
                if (v.payWay === '1') {
                  v.payWayText = '支付宝'
                } else if (v.payWay === '2') {
                  v.payWayText = '微信'
                } else if (v.payWay === '3') {
                  v.payWayText = '银行转账'
                } else if (v.payWay === '4') {
                  v.payWayText = '线下缴费'
                }
                if (v.payTime) {
                  v.payTime = v.payTime.slice(0, 19)
                }

                if (v.payStatus === '0') {
                  v.payStatusText = '未缴费'
                } else if (v.payStatus === '1') {
                  v.payStatusText = '已缴费'
                } else if (v.payStatus === '2') {
                  v.payStatusText = '已退款'
                }
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取信息失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },

      modifyInvoiceStatus (data) {
        // if (data.invoiceStatus === '1') {
        //   nError('已开票的不允许修改')
        //   return false
        // } else {
        //
        // }

        data.invoiceStatusChangeStatus = false
        this.currentLineData = data
      },
      // 修改开票状态
      statusChange (data) {
        this.currentLineData.invoiceStatus = data
        for (let i in this.currentLineData) {
          if (this.currentLineData[i] === '--') {
            this.currentLineData[i] = ''
          }
        }
        if (data === '0' || data === '2') {
          this.currentLineData.invoiceNo = ''
          this.$axios.post(api.updateRepairBill, this.currentLineData)
            .then(res => {
              nSuccess('修改成功')
              this.getPage()
            })
            .catch(errorHandler('修改失败'))
        }
      },
      // 修改发票号
      statusInfoChange () {
        if (!this.currentLineData.invoiceNo) {
          nError('请输入发票号')
          return false
        }
        this.$axios.post(api.updateRepairBill, this.currentLineData)
          .then(res => {
            nSuccess('修改成功')
            this.getPage()
          })
          .catch(errorHandler('修改失败'))
      },

      // 批量修改发票状态
      updatePatchElectricConsumptionRecord () {
        let reqData = []
        let sumMoney = 0
        this.selectionArr.map(selection => {
          this.tableData.map(v => {
            if (selection === v.code && v.invoiceStatus === '0') {
              for (let i in v) {
                if (v[i] === '--') {
                  v[i] = ''
                }
              }
              reqData.push(v)
              reqData[reqData.length - 1].invoiceStatus = '1'
              sumMoney = sumMoney + parseFloat(v.money)
            }
          })
        })
        if (reqData.length === 0) {
          nError('请选择未开票的充值记录')
          return false
        }
        this.$confirm(`本次开票总金额为：${sumMoney.toFixed(2)} 元，已开票的不计入在内，请核对信息`, '温馨提示', {
          type: 'info'
        })
          .then(() => {
            this.$axios.post(api.updatePatchElectricConsumptionRecord, reqData)
              .then(res => {
                nSuccess('修改成功')
                this.getPage()
              })
              .catch(() => {
                errorHandler('修改失败')
                this.getPage()
              })
          })
          .catch(() => {
            this.getPage()
          })
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Finance/repairFinance/repairFinancePayRecord.vue